
const digest = 'f1985801766eb91a4c3887d2d41ea2a938bb1ddd50d148584e491071cde5139d';
const classes = {"wrapper":"_wrapper_t24ig_1","header":"_header_t24ig_4","title":"_title_t24ig_10","textarea":"_textarea_t24ig_16","footer":"_footer_t24ig_20","actionsWrapper":"_actionsWrapper_t24ig_24"};
const css = `._wrapper_t24ig_1 {
  padding: 15px;
}
._wrapper_t24ig_1 ._header_t24ig_4 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._wrapper_t24ig_1 ._header_t24ig_4 ._title_t24ig_10 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 16px;
}
._wrapper_t24ig_1 ._textarea_t24ig_16 {
  min-height: 194px;
}

._footer_t24ig_20 {
  gap: 40px;
}

._actionsWrapper_t24ig_24 {
  gap: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  